/*{ ------------------- Icons & Buttons ------------------------} */
import AddIcon from '@mui/icons-material/Add';
import deleteIcon from "../../assets/images/delete.svg"
import EditIcon from "../../assets/images/editIcon.png"
import { AiOutlineCloudUpload } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { FaVideo } from "react-icons/fa";
import { Avatar, AvatarGroup } from '@mui/material';

/*{ ------------------- import components ------------------------} */
import FormField from '../../components/Common-components/form-input';
import TableHeadings from '../../components/Common-components/table-headings';
import SearchFilter from '../../components/Common-components/serchFillter';
import { Spinner } from '../../components/Common-components/spinner';
import { Pagination } from '../../components/Pagination';
import Modal from '../../components/PopUpModal'
import DeleteModal from '../../components/Modal/delete-modal';
import DateInput from '../../components/DateInput'
import { Validation, imageBaseUrl } from '../../components/Constant';
import useDragDrop from '../../hooks/useDrag&Drop';
import useMuiCustom from '../../hooks/useMuiCustom';
import useLanguage from '../../hooks/useLanguage';
import moment from 'moment-timezone';
import usePastEvent, { MAX_PAST_EVENT_MEDIA } from './hook/usePastEvent';

export const pastEventStatusColor = { Pending: "#F5A623", Approved: "#44D36C", Rejected: "#E5484D" }

const PastEvent = () => {
    const { t } = useLanguage();
    const { methods, data } = usePastEvent();
    const { CustomWidthTooltip } = useMuiCustom();
    const { handlePagination, handleClosedModal, handleOpenModal,
        handleInputChange,
        handleBlur,
        handleAddSubmit,
        handleDelete,
        uploadMedia,
        removeMedia,
        HandleSearch, handleChangeFilter, reset
    } = methods
    const { controller, TableHeadData, totalCount, openModal, uploadImgRef,
        pastEventInput,
        error,
        spinner,
        filter,
        listData,
    } = data
    const { handleDragEnter, handleDragLeave, handleDragOver, handleDrop } = useDragDrop()

    const mediaUrl = (file) => `${imageBaseUrl}pastEvent/${file}`
    const isVideo = (file) => Validation?.pattern?.isValidVideo.test(file)

    return (
        <>
            {spinner && <Spinner />}
            <div className='container-fluid d-flex flex-column justify-content-between flex-fill h-100'>
                <h1 className="font-18 black-color pb-2 px-2">{`${t('sideBar.pastEvents')}`}</h1>
                <div className='px-2'>
                    <div className=" d-flex justify-content-start">
                        <SearchFilter
                            handleSearch={HandleSearch}
                            handleFilterInput={handleChangeFilter}
                            value={filter?.search}
                            reset={reset}
                            otherAction={
                                <button
                                    className="custom_button ms-3  bg-green-color white-color align-items-center"
                                    onClick={() => handleOpenModal("addPastEvent")}>
                                    <AddIcon size={20} className="me-1" />
                                    <span className="me-1"> {`${t("buttonTitle.add")} ${t("pastEvent.pastEvent")}`} </span>
                                </button>
                            }
                        />
                    </div>
                </div>

                <div className="table-responsive custom_table px-2 flex-fill mt-3 custom_scroll">
                    <table className="table cus-table">
                        <TableHeadings TableHeadData={TableHeadData} controller={controller} setController={handlePagination} />
                        <tbody>
                            {listData?.map((cur, index) => (
                                <>
                                    <tr key={cur?._id}>
                                        <td>{controller?.rowsPerPage * (controller?.page - 1) + index + 1}</td>
                                        <td>
                                            <div className="d-flex justify-content-center">
                                                <AvatarGroup max={4}>
                                                    {cur?.images?.map((file) => (
                                                        isVideo(file)
                                                            ? <Avatar key={file}><FaVideo size={14} /></Avatar>
                                                            : <Avatar key={file} alt={file} src={mediaUrl(file)} />
                                                    ))}
                                                </AvatarGroup>
                                            </div>
                                        </td>
                                        <td>{cur?.name}</td>
                                        <td>{cur?.eventDate ? moment(cur?.eventDate).format('DD/MM/YYYY') : '--'}</td>
                                        <td>
                                            <span className='fw-6' style={{ color: pastEventStatusColor[cur?.status] }}>{t(`pastEvent.${cur?.status}`)}</span>
                                            {cur?.status === "Rejected" && cur?.rejectReason && <div className='font-11 grey-color1'>{`${t("filterTitle.reason")}: ${cur?.rejectReason}`}</div>}
                                        </td>
                                        <td>
                                            <CustomWidthTooltip title={<span className="fw-4 font-12 black-color">{`${t("buttonTitle.delete")}`}</span>} placement="left-start" >
                                                <img src={deleteIcon} alt="" className='me-2 cursor' onClick={() => handleOpenModal("deletePastEvent", cur)} />
                                            </CustomWidthTooltip>
                                            <CustomWidthTooltip title={<span className="fw-4 font-12 black-color">{`${t("buttonTitle.edit")}`}</span>} placement="left-start" >
                                                <img src={EditIcon} alt="" className='me-2 cursor' onClick={() => handleOpenModal("addPastEvent", cur)} />
                                            </CustomWidthTooltip>
                                        </td>
                                    </tr>
                                    <tr className='default_tr_gap'></tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    {!listData?.length && <div className="text-center my-2">{`${t("tableTitle.noRecordFound")}`}</div>}
                </div >
                {
                    totalCount > 10 && <div >
                        <Pagination count={totalCount} controller={controller} setController={handlePagination} />
                    </div>
                }

                {/* Add / Edit Past Event */}
                <Modal className="p-0"
                    size="lg"
                    onHide={() => handleClosedModal('addPastEvent')}
                    show={openModal?.addPastEvent}
                    headerBorderBottom={false}
                    headerContent={<h5 className="m-0 black-color fw-6 font-15 text-center w-100">
                        {`${openModal?.data ? t("buttonTitle.edit") : t("buttonTitle.add")}  ${t("pastEvent.pastEvent")} `}</h5>}
                    bodyContent={
                        <div className="container-fluid">
                            {openModal?.data?.status === "Approved" &&
                                <div className='font-12 mb-2 p-2 rounded' style={{ background: "#FFF6E5", color: "#9A6100" }}>{t("pastEvent.editReapprovalNote")}</div>
                            }
                            <div className="row">
                                <div className="col-md-6 mt-2">
                                    <FormField required={true}
                                        name={'name'}
                                        value={pastEventInput?.name}
                                        onBlur={(e) => handleBlur(e)}
                                        onChange={(e) => handleInputChange(e)}
                                        data={{ label: `${t("pastEvent.eventName")}`, type: 'text' }}
                                        error={error?.name}
                                    />
                                </div>
                                <div className="col-md-6 mt-2">
                                    <DateInput
                                        maxDate={new Date()}
                                        isRequired={true}
                                        size="small"
                                        variant="outlined"
                                        className=" form-field-design w-100 fullWidth black-color"
                                        Label={`${t("pastEvent.eventDate")}`}
                                        SelectedDate={pastEventInput?.eventDate || null}
                                        error={error?.eventDate}
                                        handleDateChange={(date) => handleInputChange({ target: { name: "eventDate", value: date } })}
                                    />
                                </div>

                                <div className="col-12 mt-3">
                                    <div className='d-flex justify-content-between font-12 grey-color1 mb-2'>
                                        <span>{t("pastEvent.imagesAndVideos")}<span className="text-danger">*</span></span>
                                        <span>{`${pastEventInput?.images?.length || 0}/${MAX_PAST_EVENT_MEDIA}`}</span>
                                    </div>
                                    <div className="d-flex flex-wrap">
                                        {pastEventInput?.images?.map((file, index) => (
                                            <div
                                                key={file}
                                                className='rounded me-2 mb-2 position-relative bg-blur'
                                                style={{ width: "140px", height: "110px" }}
                                            >
                                                {isVideo(file) ? (
                                                    <video playsInline muted loop autoPlay className='w-100 h-100' style={{ objectFit: 'cover', borderRadius: '8px' }}>
                                                        <source src={mediaUrl(file)} />
                                                    </video>
                                                ) : (
                                                    <img className='rounded' src={mediaUrl(file)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                )}
                                                <span
                                                    className='position-absolute cursor bg-white rounded-circle d-flex'
                                                    style={{ top: "4px", right: "4px", color: "black", padding: "2px" }}
                                                    onClick={() => removeMedia(index)}
                                                >
                                                    <IoClose />
                                                </span>
                                            </div>
                                        ))}
                                    </div>

                                    {
                                        (pastEventInput?.images?.length || 0) < MAX_PAST_EVENT_MEDIA && <div
                                            className="drag-drop w-100"
                                            style={{ border: `2px dashed #2F90EA` }}
                                            onDragEnter={handleDragEnter}
                                            onDragLeave={handleDragLeave}
                                            onDragOver={handleDragOver}
                                            onDrop={(e) => handleDrop(e, uploadMedia, "multiple")}
                                        >
                                            <label htmlFor="pastEventMediaInput" className='w-100'>
                                                <AiOutlineCloudUpload className="fs-4 blue-color" />
                                                <input
                                                    accept="image/*,video/*"
                                                    id="pastEventMediaInput"
                                                    type="file"
                                                    name="file"
                                                    ref={uploadImgRef}
                                                    onChange={(event) => uploadMedia(event.target.files)}
                                                    multiple
                                                />
                                                <br />
                                                <p className="mb-0 blue-color font-12 mt-2">
                                                    {`${t("formTitle.drag&Drop")}`}
                                                </p>
                                                <p className="mb-0 grey-color1 font-11 mt-1">{t("pastEvent.maxMediaHint")}</p>
                                                <div className='horizontal_line my-3'>
                                                    <span>{`${t("formTitle.or")}`}</span>
                                                </div>
                                                <p className="custom_button bg-blue-color white-color font-12 px-2 py-2 mt-0 cursor d-inline-block">
                                                    {`${t("buttonTitle.selectFileUpload")}`}
                                                </p>
                                            </label>
                                        </div>
                                    }
                                    {
                                        error?.images && <div className='font-11 mt-1 red-color'>{error?.images}</div>
                                    }
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-center py-4">
                                <button className="custom_button bg-blue-color2 white-color font-14 px-4 py-2" onClick={handleAddSubmit}> {openModal?.data?._id ? `${t("buttonTitle.update")}` : `${t("buttonTitle.submit")}`}</button>
                            </div>
                        </div>
                    }
                />
            </div >
            <DeleteModal show={openModal?.deletePastEvent} closeModal={() => handleClosedModal('deletePastEvent')} handleDelete={handleDelete} deleteName={openModal?.data?.name} deleteTtpe={`${t("buttonTitle.delete")}`} />
        </>
    )
}
export default PastEvent
